import Backbone from 'backbone';
import _ from 'underscore';
import Bowser2 from 'bowser';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';

var Feedback = Backbone.Model.extend({
    defaults: {
        account_id               : 0,
        user_id                  : 0,
        project_id               : 0,
        uploader_user_id         : 0,
        uploader_portal_user_id  : 0,
        session_recording_id     : 0,
        session_id               : '',
        approve_request_user_id  : 0,
        unsubscribe_key          : '',
        share_key                : '',
        load_type                : 'web',
        feedback_type            : 0,
        user_identification      : '',
        page                     : '',
        page_title               : '',
        is_local                 : false,
        is_auto_screenshot       : false,
        is_portal_approved       : false,
        is_pinned                : false,
        email                    : '',
        title                    : '',
        description              : '',
        is_desc_resolved         : false,
        name                     : '',
        screenshot               : '',
        video_url                : '',
        video_length             : 0,
        attachment               : '',
        ip                       : '',
        time                     : 0,
        last_update_time         : 0,
        due_date                 : 0,
        last_due_date_sent       : 0,
        last_due_reminder_sent   : 0,
        user_agent               : '',
        ua_data                  : '',
        window_x                 : 0,
        window_y                 : 0,
        window_top               : 0,
        window_left              : 0,
        resolution_x             : 0,
        resolution_y             : 0,
        dpi                      : 0,
        colour_depth             : 0,
        workflow                 : 0,
        is_shared                : false,
        vote_count               : 0,
        allow_public_comment     : false,
        allow_video_feedback     : true,
        priority                 : 'neutral',
        category                 : '',
        rating                   : '',
        latitude                 : '',
        longitude                : '',
        country_code             : '',
        country                  : '',
        city                     : '',
        subdivision_code         : '',
        subdivision              : '',
        postal                   : '',
        jira_url                 : '',
        trello_url               : '',
        basecamp_url             : '',
        github_url               : '',
        gitlab_url               : '',
        linear_url               : '',
        asana_url                : '',
        clickup_url              : '',
        wrike_url                : '',
        teamwork_url             : '',
        monday_url               : '',
        zendesk_url              : '',
        notion_url               : '',
        sentiment                : 0,
        action_required          : Constants.ACTION_REQUIRED_NOT_SET

    },

    _bowser_detection: false,

    isDesign: function() {
        var file_extension = Util.fileExtension(this.get('screenshot'));
        return this.get('load_type') === 'upload' && file_extension && file_extension.toLowerCase() !== 'pdf' && !this.get('video_url');
    },

    isPdf: function() {
        var file_extension = Util.fileExtension(this.get('screenshot'));
        return this.get('load_type') === 'upload' && file_extension && file_extension.toLowerCase() === 'pdf' && !this.get('video_url');;
    },

    isVideoUpload: function() {
        return this.get('load_type') === 'upload' && this.get('video_url');
    },

    getVoteCount: function() {
        if (this.isMergedFeedback()) {
            return 0;
        }

        if (this.get('vote_count') >= 1000) {
            return (this.get('vote_count') / 1000).toFixed(1) + 'k';
        } else {
            return this.get('vote_count');
        }
    },

    getBowserDetection: function() {
        if (!this._bowser_detection) {
            var user_agent = this.get('user_agent') || 'unknown';
            this._bowser_detection = Bowser2.getParser(user_agent);
        }

        return this._bowser_detection;
    },

    getFeedbackTypeName: function(include_icon) {
        var icon = '';
        var text = '';

        switch (this.get('feedback_type')) {
            case Constants.FEEDBACK_BUG:
                icon = '<span class="text-info margin-right-4"><i class="fa-regular fa-bug"></i></span>';
                text = 'Bug';
                break;
            case Constants.FEEDBACK_FEATURE_REQUEST:
                icon = '<span class="text-info margin-right-4"><i class="fa-regular fa-hand-sparkles"></i></span>';
                text = 'Idea';
                break;
            case Constants.FEEDBACK_GENERAL:
                icon = '<span class="text-info margin-right-4"><i class="fa-regular fa-file-lines"></i></span>';
                text = 'General';
                break;
        }

        if (include_icon) {
            return icon + text;
        } else {
            return text;
        }
    },

    getFeedbackIcon: function() {
        switch (this.get('feedback_type')) {
            case Constants.FEEDBACK_BUG:
                return '<span class="tooltip" data-title="Bug"><i class="fa-light fa-bug"></i></span>';
                break;
            case Constants.FEEDBACK_FEATURE_REQUEST:
                return '<span class="tooltip" data-title="Idea"><i class="fa-light fa-hand-sparkles"></i></span>';
                break;
            case Constants.FEEDBACK_GENERAL:
                return '<span class="tooltip" data-title="General Feedback"><i class="fa-light fa-file-lines"></i></span>';
                break;
        }
    },

    getBrowser: function(fallback) {
        var fallback_browser = typeof fallback !== 'undefined' ? fallback : 'Unknown';

        if (!this.get('user_agent')) {
            return fallback_browser;
        }

        var browser = this.getBowserDetection();
        var browser_version = browser.getBrowserVersion();

        var feedback_browser = '';

        if (browser_version) {
            browser_version = browser_version.split('.');

            if (browser_version.length >= 3) {
                browser_version = browser_version[0] + '.' + browser_version[1];
            } else {
                browser_version = browser_version.join('.');
            }

            feedback_browser = browser.getBrowserName() + ' ' + browser_version;
        } else {
            feedback_browser = browser.getBrowserName();
        }

        return feedback_browser || fallback_browser;
    },

    getBrowserIcon: function() {
        var browser = this.getBowserDetection();

        switch (browser.getBrowserName()) {
            case 'Chrome':
                return '<img class="browser-meta-logo" src="/image/chrome_logo.png">';
                break;
            case 'Firefox':
                return '<img class="browser-meta-logo" src="/image/firefox_logo.png">';
                break;
            case 'Internet Explorer':
                return '<img class="browser-meta-logo" src="/image/ie_logo.png">';
                break;
            case 'Microsoft Edge':
                return '<img class="browser-meta-logo" src="/image/edge_logo.png">';
                break;
            case 'Safari':
                return '<img class="browser-meta-logo" src="/image/safari_logo.png">';
                break;
        }

        return '';
    },

    getSentimentIcon: function() {
        switch (this.get('sentiment')) {
            case 1:
                return Svg_Icon.face_hate;
            case 2:
                return Svg_Icon.face_neutral;
            case 3:
                return Svg_Icon.face_love;
        }

        return '';
    },

    getSentimentText: function() {
        switch (this.get('sentiment')) {
            case 1:
                return 'Negative';
            case 2:
                return 'Neutral';
            case 3:
                return 'Positive';
        }

        return '';
    },

    getRatingIcon: function() {
        var rating = this.get('rating');
        var rating_type = 'emoji';

        if (rating.indexOf('heart') !== -1) {
            rating_type = 'heart';
            rating = rating.replace(/heart_/, '');
        } else if (rating.indexOf('star') !== -1) {
            rating_type = 'star';
            rating = rating.replace(/star_/, '');
        } else if (rating.indexOf('thumb') !== -1) {
            rating_type = 'thumb';
            rating = rating.replace(/thumb_/, '');
        } else if (Util.isNumeric(rating)) {
            rating_type = 'number';
        } else {
            rating_type = 'emoji';
        }

        var rating_icon = '-';
        if (rating) {
            if (rating_type === 'star') {
                rating_icon = '<div class="' + (rating < 1 ? 'inactive' : '') + '">' + Svg_Icon.star + '</div>' +
                              '<div class="' + (rating < 2 ? 'inactive' : '') + '">' + Svg_Icon.star + '</div>' +
                              '<div class="' + (rating < 3 ? 'inactive' : '') + '">' + Svg_Icon.star + '</div>' +
                              '<div class="' + (rating < 4 ? 'inactive' : '') + '">' + Svg_Icon.star + '</div>' +
                              '<div class="' + (rating < 5 ? 'inactive' : '') + '">' + Svg_Icon.star + '</div>';
            } else if (rating_type === 'heart') {
                rating_icon = '<div class="' + (rating < 1 ? 'inactive' : '') + '">' + Svg_Icon.heart + '</div>' +
                              '<div class="' + (rating < 2 ? 'inactive' : '') + '">' + Svg_Icon.heart + '</div>' +
                              '<div class="' + (rating < 3 ? 'inactive' : '') + '">' + Svg_Icon.heart + '</div>' +
                              '<div class="' + (rating < 4 ? 'inactive' : '') + '">' + Svg_Icon.heart + '</div>' +
                              '<div class="' + (rating < 5 ? 'inactive' : '') + '">' + Svg_Icon.heart + '</div>';
            } else if (rating_type === 'thumb') {
                rating_icon = '<div class="thumb-up'   + (rating !== 'up'   ? ' inactive' : '') + '">' + Svg_Icon.thumb_up + '</div>' +
                              '<div class="thumb-down' + (rating !== 'down' ? ' inactive' : '') + '">' + Svg_Icon.thumb_down + '</div>';
            } else if (rating_type === 'number') {
                rating_icon = '<div class="number' + (rating == 1 ? ' active' : '') + '">1</div>' +
                              '<div class="number' + (rating == 2 ? ' active' : '') + '">2</div>' +
                              '<div class="number' + (rating == 3 ? ' active' : '') + '">3</div>' +
                              '<div class="number' + (rating == 4 ? ' active' : '') + '">4</div>' +
                              '<div class="number' + (rating == 5 ? ' active' : '') + '">5</div>';
            } else {
                rating_icon = '<div class="tooltip' + (rating === 'hate'    ? '' : ' inactive') + '" data-title="Hate">'    + Svg_Icon.face_hate    + '</div>' +
                              '<div class="tooltip' + (rating === 'dislike' ? '' : ' inactive') + '" data-title="Dislike">' + Svg_Icon.face_dislike + '</div>' +
                              '<div class="tooltip' + (rating === 'neutral' ? '' : ' inactive') + '" data-title="Neutral">' + Svg_Icon.face_neutral + '</div>' +
                              '<div class="tooltip' + (rating === 'like'    ? '' : ' inactive') + '" data-title="Like">'    + Svg_Icon.face_like    + '</div>' +
                              '<div class="tooltip' + (rating === 'love'    ? '' : ' inactive') + '" data-title="Love">'    + Svg_Icon.face_love    + '</div>';
            }
        }

        return rating_icon;
    },

    getOs: function() {
        var browser = this.getBowserDetection();
        var os = browser.getOS();

        var os_name = browser.getOSName();
        var os_version = (os.versionName || browser.getOSVersion() || '');

        try {
            var ua_data = JSON.parse(this.get('ua_data'));

            var ua_platform_name    = ua_data.platform ? ua_data.platform.toLowerCase() : null;
            var ua_platform_version = ua_data.platformVersion || null;

            if (ua_platform_version) {
                if (ua_platform_name === 'windows') {
                    if (parseInt(ua_platform_version.split('.')[0], 10) > 13) {
                        // Windows 11
                        os_version = 11;
                    }
                } else if (ua_platform_name === 'macos') {
                    switch (parseInt(ua_platform_version.split('.')[0], 10)) {
                        case 11:
                            os_version = 'Big Sur ' + ua_platform_version;
                            break;
                        case 12:
                            os_version = 'Monterey ' + ua_platform_version;
                            break;
                        case 13:
                            os_version = 'Ventura ' + ua_platform_version;
                            break;
                        case 14:
                            os_version = 'Sonoma ' + ua_platform_version;
                            break;
                    }
                }
            }
        } catch(e) {
        }

        return (os_name ? os_name + ' ' : '') + os_version;
    },

    isTablet: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatformType() === 'tablet';
    },

    isPhone: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatformType() === 'mobile';
    },

    isApple: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatform().vendor === 'Apple';
    },

    isAndroid: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Android';
    },

    isWindowsPhone: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows Phone';
    },

    isWindows: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows';
    },

    isLinux: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Linux';
    },

    getReporterAvatar: function(size) {
        size = size || 32;

        var uploader_user = Cache.user.get(this.get('uploader_user_id'));

        if (uploader_user) {
            return uploader_user.getAvatar(size);
        } else {
            return Util.gravatar(this.get('email'), 32, this.get('name'));
        }
    },

    getReporterName: function() {
        var reporter_name = '';

        if (!this.get('name') && !this.get('email')) {
            reporter_name = 'anonymous';
        } else if (this.get('name')){
            reporter_name = this.get('name');
        } else if (this.get('email')) {
            reporter_name = this.get('email');
        }

        return reporter_name;
    },

    getSource: function() {
        switch (this.get('load_type')) {
            case 'app':
                return 'Manual Upload';
            case 'api':
                return 'API';
            case 'intercom_messenger':
                return 'Intercom Messenger';
            case 'csv':
                return 'CSV Upload';
            case 'email':
                return 'Email Forwarding';
            case 'portal':
                return 'Ideas Portal';
            case 'extension':
            case 'chrome_extension':
            case 'firefox_extension':
            case 'edge_extension':
                return 'Browser Extension';
            case 'upload':
                return 'File Upload'; // design feedback
            default:
                return 'Widget';
        }

    },

    // Portal: return total comments
    getTotalComments: function(exclude_screen_comments) {
        var total_comments = 0;

        Cache.feedback_comment.where({feedback_id: this.id}).forEach(function(model) {
            if (!model.get('comment')) {
                return;
            }

            if (exclude_screen_comments) {
                if (model.get('screen_number') !== 0 || model.get('video_time') !== 0) {
                    return;
                }

                var reply_comment_id = model.get('reply_comment_id');

                // no pin comments
                if (reply_comment_id &&
                    Cache.feedback_comment.get(reply_comment_id) &&
                    Cache.feedback_comment.get(reply_comment_id).get('screen_number')) {
                        return;
                }

                // no bookmark comments
                if (reply_comment_id &&
                    Cache.feedback_comment.get(reply_comment_id) &&
                    Cache.feedback_comment.get(reply_comment_id).get('video_time')) {
                        return;
                }
            }

            total_comments++;
        });

        return total_comments;
    },

    getMergedFeedbackIds: function() {
        var merged_feedback_ids = this.get('merged_feedback_ids');

        return merged_feedback_ids || [];
    },

    getMergedFeedbackCount: function() {
        return this.getMergedFeedbackIds().length;
    },

    isPrimaryFeedback: function() {
        var merged_feedback_count = this.getMergedFeedbackCount();

        return merged_feedback_count > 0;
    },

    isMergedFeedback: function() {
        return this.get('primary_feedback_id') > 0;
    },

    getSubject: function() {
        var subject = '';

        if (this.isDesign() && this.isPdf()) {
            subject = this.get('page');
        } else if (this.get('title')) {
            subject = this.get('title');
        } else if (this.get('description')) {
            subject = this.get('description');
        } else {
            subject = this.get('page');
        }

        return subject;
    },

    isDueToday: function() {
        if (this.get('due_date') === 0) {
            return false;
        }

        var project_workflow = Cache.workflow.where({project_id: this.get('project_id')});

        if (!project_workflow.length) {
            return false;
        }

        var is_resolved = this.get('workflow') === project_workflow[project_workflow.length - 1].id;
        var is_same_day = Util.isSameDay(Util.nowUnix(), this.get('due_date'));

        return is_same_day && !is_resolved ? true : false;
    },

    isOverdue: function() {
        if (this.get('due_date') === 0) {
            return false;
        }

        var project_workflow = Cache.workflow.where({project_id: this.get('project_id')});

        if (!project_workflow.length) {
            return false;
        }

        var is_resolved = this.get('workflow') === project_workflow[project_workflow.length - 1].id;

        var due_date_timestamp = this.get('due_date');
        var current_timestamp = Util.nowUnix();

        var due_date_start = Util.startOfDay(due_date_timestamp);
        var current_start = Util.startOfDay(current_timestamp);

        return !is_resolved && due_date_start < current_start ? true : false;
    },

    getReporter: function(user_cache) {
        if (this.get('email')) {
            var user = user_cache?.get(this.get('uploader_user_id'));

            if (user) {
                return {
                    type  : 'internal',
                    email : user.get('email'),
                    name  : user.get('name')
                };
            } else {
                return {
                    type  : 'public',
                    email : this.get('email'),
                    name  : this.get('name') || ''
                };
            }
        }
        return null;
    },

    isExpired: function() {
        if (Cache.account.isFreePlan()) {
            if (this.get('days_old') !== undefined) {
                return this.get('days_old') > Constants.FREE_FEEDBACK_EXPIRY ? true : false;
            } else {
                // Fallback to computer clock when the days_old is not set in the backend
                // Should not happen
                var now = Date.now() / 1000;
                var expiry_date = Constants.FREE_FEEDBACK_EXPIRY * 24 * 60 * 60;

                return this.get('time') < now - expiry_date ? true : false;
            }
        }

        return false;
    }
});

export default Feedback;
